import { Box, BoxProps, ColorOptions, Icon, Spacer } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import { Text } from '@jfs/ui-new/src/comps/TextNew'
import React, { FC, useEffect, useRef } from 'react'
import { convertHexToRGBA } from '../../utils'

export interface SearchBarProps {
  onPress?: () => void
  onChange?: (text: string) => void
  placeholder?: string
  value?: string
  hide?: boolean
  isSearch?: boolean
  autoFocus?: boolean
  theme?: any
}

const shadow = {
  shadowColor: 'BLACK',
  shadowOffset: {
    width: 0,
    height: 0.5,
  },
  shadowOpacity: 0.1,
  shadowRadius: 3,
  elevation: 2,
}

const styles = {
  container: (theme: any) =>
    ({
      ...shadow,
      flexDirection: 'row',
      paddingHorizontal: 24,
      alignItems: 'center',
      height: 48,
      width: '100%',
      borderRadius: 8,
      backgroundColor: theme ? convertHexToRGBA(theme?.bodyTextColor as ColorOptions, 10) : 'WHITE',
      underlayColor: theme ? convertHexToRGBA(theme?.bodyTextColor as ColorOptions, 10) : 'WHITE',
    } as BoxProps),
}

export const TOneSearchBar: FC<SearchBarProps> = (props) => {
  const { placeholder = 'Search', onChange, onPress, value, hide, autoFocus, theme, isSearch = false } = props
  const textInputRef = useRef<RNTextInput>(null)
  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        if (textInputRef.current) {
          textInputRef.current.focus()
        }
      }, 100)
    }
  }, [autoFocus])

  if (hide) {
    return null
  }

  const handleChange = (text: string) => {
    onChange && onChange(text)
  }
  const leftComponent = (
    <Icon
      id="SEARCH"
      size={20}
      color={theme ? (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions) : 'LIGHT_GREY'}
    />
  )

  const LeftComponent = () => (
    <Icon
      id="SEARCH"
      size={20}
      color={theme ? (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions) : 'LIGHT_GREY'}
    />
  )
  const containerOnPress = () => {
    if (textInputRef.current) {
      textInputRef.current.focus()
    }
  }

  const handleOnPress = () => {
    onPress && onPress()
  }

  if (isSearch) {
    return (
      <Box {...styles.container(theme)} onPress={containerOnPress} testID="searchBarBox">
        <TextInput
          showBottomLine={false}
          leftComponent={leftComponent}
          placeholder={placeholder}
          type="h2"
          onChange={handleChange}
          autoCorrect={false}
          autoCompleteType="name"
          autoCapitalize="none"
          value={value}
          innerRef={textInputRef}
          color={theme ? (theme?.bodyTextColor as ColorOptions) : 'BLACK_21'}
          placeholderTextColor={theme ? (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions) : 'LIGHT_GREY'}
        />
      </Box>
    )
  }

  return (
    <Box {...styles.container(theme)} onPress={handleOnPress} testID="searchBarBox">
      <LeftComponent />
      <Spacer direction="horizontal" size={12} />
      <Text
        fontSize={12}
        fontWeight="500"
        color={theme ? (convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions) : 'BLACK'}>
        {placeholder}
      </Text>
    </Box>
  )
}
